<template>
  <div>
    <div class="bell-code">门铃编码：{{ formData.deviceCode }}</div>
    <el-form
      :model="formData"
      :rules="rules"
      v-loading="saveLoading"
      ref="editForm"
      label-position="top"
      class="form-horizontal detail-form paddingTopDetail employeeEditDetail"
    >
      <el-form-item prop="roomId" class="is-required" label="房源名称：">
        <el-select v-model="formData.roomId" placeholder="请选择" filterable>
          <el-option
            v-for="item in roomList"
            :key="item.id"
            :label="item.roomName + '(' + item.roomCode + ')'"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <div class="bottom-btn">
        <el-button class="submit-btn" @click="handleSave">绑定</el-button>
        <el-button class="cancel-btn" @click="handleClose">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "bellBindModel",
  props: {
    storeId: {
      type: [Number, String],
      default: ''
    },
    detailModal: {
      type: Boolean,
      default: "",
    },
    detailData: {
      type: Object,
      default: () => ({ deviceCode: "" }),
    },
    deviceType: {
      type: [Number, String],
      default: 104
    }
  },
  data() {
    return {
      saveLoading: false,
      rules: {
        roomId: [{ required: true, message: "请选择房源", trigger: "blur" }],
      },
      formData: {
        deviceCode: '',
        managerCode: '',
        roomId: ''
      },
      roomList: [],
      managerList: []
    };
  },
  created() {
    this.$nextTick(() => {
      this.getRoomList()
      this.initFormData();
    });
  },
  watch: {
    detailModal(val) {
      if (val === false) {
        return false;
      }
      this.$nextTick(() => {
        // this.getManagerList()
        this.getRoomList()
        this.initFormData();
      });
    },
  },
  methods: {
    ...mapActions(["fetchData"]),
    // 初始化表单数据
    initFormData() {
      for (let key in this.formData) {
        this.formData[key] = ''
      }
      this.formData.deviceCode = this.detailData.deviceCode
    },
    // 处理经营者切换
    handleChangeManager() {
      this.formData.roomId = ''
      this.getRoomList()
    },
    // 获取经营者列表
    getManagerList() {
      let params = {};
      let url = 'MANAGER.GET_LIST'

      this.fetchData({ url, method: "get", params }).then((res) => {
        res = res || {}
        if (!res.data || res.data.length === 0) {
          return this.$message.error('获取经营者失败！')
        }
        this.managerList = res.data || []
      })
    },
    // 查询列表数据
    getRoomList() {
      let params = {
        storeId: this.storeId || '',
        deviceType: this.deviceType,
      };

      let url = "DEVICE.GET_NO_BIND_ROOM";
      this.fetchData({ url, method: "get", params }).then((res) => {
        if (!res || res.length === 0) {
          this.roomList = []
          return
        }
        this.roomList = res || []
      });
    },
    //保存与发布
    handleSave() {
      this.saveLoading = true;
      
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.doSave();
        } else {
          this.saveLoading = false;
        }
      });
    },
    // 执行绑定
    doSave() {
      let url = "DEVICE.GET_BIND";
      let params = {
        roomId: this.formData.roomId,
        deviceCode: this.formData.deviceCode,
        deviceType: this.deviceType,
      };

      this.fetchData({ url: url, method: "get", params }).then((res) => {
        if (res === '绑定成功！' || res === '绑定虚拟锁成功！') {
          this.$message.success(res)
          this.$emit("submitSuccess");
        } else {
          this.$message.warning(res)
        }
      }).catch((err) => {
        this.$message.error("操作失败！");
      }).finally(() => {
        this.saveLoading = false;
      });
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.bell-code {
  margin-left: 5%;
  margin-bottom: 15px;
  font-size: 14px;
}
.employeeEditDetail {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 90% !important;
}
.employeeEditDetail :deep(.el-form-item),
.employeeEditDetail :deep(.el-select) {
  width: 100%;
}
.employeeEditDetail .el-form-item.rowItem {
  width: 100% !important;
}
.employeeEditDetail .detailContent {
  padding: 0px;
}
.bottom-btn {
  padding-top: 10px;
  text-align: center;
  width: 100%;
}
</style>
